<template>
  <v-row>
    <v-col md="8" offset-md="2" xl="6" offset-xl="3">
      <BaseBlock title="Réinitialisation des données">
        <v-banner two-line>
          <v-avatar slot="icon" color="red accent-4" size="40">
            <v-icon icon="mdi-lock" color="white">
              mdi-alarm-light
            </v-icon>
          </v-avatar>

          La réinitialisation des données consiste à supprimer définitivement
          les données concernant les étudiants et les candidatures. Cette
          fonctionnalité ne doit donc être utilisée que lors de la préparation
          d'une nouvelle campagne.

          <template v-slot:actions>
            <ButtonConfirmation
              :inactif="loading"
              icone="mdi-check-bold"
              libelle="Réinitialiser"
              title="Vous allez supprimer les données des étudiants et des candidatures"
              @ok="reinitialiser"
            ></ButtonConfirmation>
          </template>
        </v-banner>
      </BaseBlock>
    </v-col>
  </v-row>
</template>
<script>
import BaseBlock from "@/components/base/BaseBlock";
import ButtonConfirmation from "@/components/ButtonConfirmation";
import ApiRazCampagneRepository from "@/repositories/ApiRazCampagneRepository";

export default {
  name: "formRazCampagne",
  components: { BaseBlock, ButtonConfirmation },
  data() {
    return { loading: false };
  },
  methods: {
    async reinitialiser() {
      this.loading = true;
      try {
        await ApiRazCampagneRepository.razCampagne();
        this.$toast.success("Les données ont été réinitialisées.");
      } catch (error) {
        this.$toast.error("La réinitialisation des données a échoué.");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
